module.exports = __webpack_public_path__ + "static/media/exercises-step1.940b5f8c.png";